module.exports = __webpack_public_path__ + "b59320d866c2aeb135d9b079d52fb4a4.svg";